/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function () {
                window.PageFunctions.smoothScroll();
                // JavaScript to be fired on all pages
                window.MenuFunctions.setupMenuToggle();
                window.MenuFunctions.searchToggle();
                //window.MenuFunctions.setupSubMenuToggle();
                window.HeaderFunctions.setupSlider();

            },
            finalize: function () {
                // JavaScript to be fired on all pages, after page specific JS is fired


                // SELECT BOXES
                $('select').niceSelect();
                $('select').niceSelect('update');
                jQuery(document).bind('gform_post_render', function () {
                    $('.gform_body').find('select').niceSelect();
                });


                // GFORM POPUPS
                $('.j-popup--toggle').on('click', function () {
                    var popup = $(this).parents('.j-popup');
                    var body = $('body');
                    body.toggleClass('no-scroll');
                    body.toggleClass('cover-up');
                    $('.o-header').toggleClass('o-header__light-temp');
                    popup.find('.j-popup--overlay').fadeToggle();

                    $('html, body').animate({
                        scrollTop: 0
                    }, 0);
                });


                window.PageFunctions.newsletterPopup();


                // Video Popup
                $('.j-video--play').on('click', function () {
                    var _this = $(this);
                    var block = _this.parents('.j-video');
                    block.addClass('is__playing');
                    block.find('iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
                });


                // lazy load images
                $('.j-lazy').each(function () {
                    var _this = $(this);
                    _this.attr('src', _this.data('src'));
                });


                $('.j-videos--slideshow').slick({
                    dots: true,
                });//

                $('.o-testimonials--carousel_slick').slick({
                        dots: true,
                        infinite: false,
                        autoplay: false,
                });

                //  Pagination
                $(".gstar-ajax-loadmore").on('click', function (event) {
                    var that = $(this);

                    event.preventDefault();
                    var post_type = that.attr('data-post-type');
                    var page = parseInt(that.attr('data-page'));
                    var per_page = parseInt(that.attr('data-per-page'));
                    var max_page = parseInt(that.attr('data-max-page'));
                    var offset = parseInt(that.attr('data-offset'));
                    var button_text = that.attr('data-button-text');
                    var tax = that.attr('data-tax');
                    var term = that.attr('data-term');


                    if (!that.hasClass('active')) {
                        that.addClass('active');
                        $('.o-index').addClass('active');

                        if (page >= max_page) {
                            that.addClass("s-hidden");
                        }
                    } else {

                        page++;

                        $.ajax({
                            url: ajaxURL,
                            type: 'post',
                            data: {
                                action: 'gstar_ajax_pagination',
                                post_type: post_type,
                                page: page,
                                per_page: per_page,
                                offset: offset,
                                button_text: button_text,
                                tax: tax,
                                term: term,
                            },
                            success: function (html) {
                                $(html).appendTo($('.j-pagination--index'));
                                that.attr('data-page', page);
                                console.log(html);
                                if (page >= max_page) {
                                    that.addClass("s-hidden");
                                }
                            }
                        });
                    }
                });
            }
        },
        // Home page
        'home': {
            init: function () {
                // JavaScript to be fired on the home page

            },
            finalize: function () {
                // JavaScript to be fired on the home page

                var banner = $(".f-banner");
                banner.on('change', '.j-banner--select', function () {
                    var _this = $(this);
                    var selected = _this.find(':selected');
                    var link = selected.val();
                    banner.find('.j-banner--button').attr('href', link);
                    /*var background = selected.data('background');
                    var img = new Image();
                    img.onload = function () {
                        banner.css('background-image', 'url(' + img.src + ')');
                        banner.find('.j-banner--button').attr('href', link);
                    }
                    img.src = background;*/

                });
            }
        },
        // Home page
        'post_type_archive_team': {
            init: function () {
                // JavaScript to be fired on the home page
            },
            finalize: function () {
                // JavaScript to be fired on the home page


                var filters = $('.o-team-filters');

                // Team Filters
                filters.on('click', '.j-team--filter', function(){
                    var button = $(this);

                    if(!button.hasClass('active')){
                        button.addClass('active').siblings().removeClass('active');
                        filter_results(button.data('filter'));
                    }
                });
                filters.on('change', '.j-team--select', function(){
                    var _this = $(this);
                    filter_results(_this.val());
                });

                if(filters.data('load-filter')){
                    filter_results(filters.data('load-filter'));
                }

                function filter_results(filter){
                   $('.j-team--single').addClass('filtered');
                    if(filter !== "*"){
                        $(filter).removeClass('filtered');
                    }else{
                        $('.j-team--single').removeClass('filtered');
                    }
                }

            }
        },
        // Home page
        'page_template_contact_php': {
            init: function () {
                // JavaScript to be fired on the home page
            },
            finalize: function () {

                window.PageFunctions.renderMap();
            }
        },

        // Home page
        'single_service': {
            init: function () {
                // JavaScript to be fired on the home page
            },
            finalize: function () {
               $('.o-service-select').on('change','select',function(){
                   var _this = $(this);
                   window.location = _this.val();
               })
            }
        },



    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.

